module.exports = {
  projectId: "homeProject",
  headerInjection: true,
  footerInjection: true,
  devPublicPath: "",
  devCrossOriginLoading: "use-credentials",
  qaPublicPath: "https://qa.cms.col.movistar.es/app/home-fusion",
  qaCrossOriginLoading: "use-credentials",
  prodPublicPath: "https://prod.cms.col.movistar.es/app/home-fusion",
  prodCrossOriginLoading: false,
  versionJs: "3.2.5",
};
